export default {
  pageSize: state => state.pageSize,
  searchTerm: state => state.searchTerm,
  filterBy: state => state.filterBy,
  sortDir: state => state.sortDir,
  orderBy: state => state.orderBy,
  filterOptions: state => state.filterOptions,
  technician: state => state.technician,
  technicians: state => state.technicians
}



// WEBPACK FOOTER //
// ./src/store/modules/technicians/getters.js